/*
 * @Author: zhangyue zhang_y1222@163.com
 * @Date: 2022-04-15 10:05:58
 * @LastEditors: zhangyue zhang_y1222@163.com
 * @LastEditTime: 2023-10-17 10:41:30
 * @FilePath: \kqcw_web\src\components\Vant.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from "vue";
import {
    Icon,
    Tab,
    Tabs,
    List,
    Cell,
    Button,
    Popup,
    Field,
    Dialog,
    Toast,
    Swipe,
    SwipeItem,
    Area,
    NavBar,
    CellGroup,
    Image,
    Sticky,
    Picker,
    Form,
    NoticeBar,
    PullRefresh,
    Loading,
    Overlay,
    DropdownMenu,
    DropdownItem,
    Empty,
    DatetimePicker,
    Col,
    Row,
    Collapse,
    CollapseItem,
    Tabbar,
    TabbarItem,
    Calendar
} from "vant";

Vue.use(Icon);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(List);
Vue.use(Cell);
Vue.use(Button);
Vue.use(Popup);
Vue.use(Field);
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Area);
Vue.use(NavBar);
Vue.use(CellGroup);
Vue.use(Image);
Vue.use(Sticky);
Vue.use(Picker);
Vue.use(Form);
Vue.use(NoticeBar);
Vue.use(PullRefresh);
Vue.use(Loading);
Vue.use(Overlay);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Empty);
Vue.use(DatetimePicker);
Vue.use(Col);
Vue.use(Row);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Calendar);